module.exports = __webpack_public_path__ + "img/073425.b634aa3c.png";